module.exports = __webpack_public_path__ + "img/8552ac1.jpg";